<ng-container *transloco="let t">
  <button data-cy="compare-btn" class="mat-button-extra-small" [class.edge-left]="edge==='left'" [class.edge-right]="edge==='right'" mat-button type="button" color="secondary" (click)="onClick()">
    <raf-icon class="start-icon" icon="compare"></raf-icon>
    {{t('PRODUCT.COMPARE')}}
  </button>
</ng-container>


